import { BlockBase, HeadlineHeader } from "components/page/user/contract/edit/parts/blockBase";
import React from "react";
import * as dateUtil from "util/dateUtil";

/** 宅地建物取引業者・宅地建物取引士（左） */
export default class Block3 extends BlockBase {
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            headlineId: "030303",
        };
    }

    render() {
        const { hideBlockClass } = this.renderCommon();

        // 非表示判定の場合、null(react的な表示なし)を返す
        if (this.dohide(this.props.pageState.hidingHeadline)) { return null; }

        let { era } = dateUtil.genEraText(this.props.pageState.JYU00010);

        return (
            <div className={`dataList dataList__accordion ${hideBlockClass}`}>
                <div className="dataList-header">
                    <div className="dataList-header-title">宅地建物取引業者・宅地建物取引士（左）</div>
                    <HeadlineHeader onClick={this.handleHide} hide={this.state.hide} />
                </div>
                <div className="dataList-body">
                    <table className="dataTable">
                        <tbody>
                            <tr>
                                <th className="dataTable-title is-emphasis" colSpan="4">宅地建物取引業者</th>
                            </tr>
                            <tr>
                                <th className="dataTable-title dataTable-title__w120 dataTable-title__center">免許番号</th>
                                <td className="dataTable-body dataTable-body__w355">{this.props.pageState.JYU00009}</td>
                                <th className="dataTable-title dataTable-title__w120 dataTable-title__center">免許年月日</th>
                                <td className="dataTable-body dataTable-body__w355">{this.props.pageState.JYU00010}&nbsp;{era}</td>
                            </tr>
                            <tr>
                                <th className="dataTable-title dataTable-title__w120 dataTable-title__center">住所</th>
                                <td className="dataTable-body dataTable-body__w355" colSpan="3">{this.props.pageState.JYU00011}</td>
                            </tr>
                            <tr>
                                <th className="dataTable-title dataTable-title__w120 dataTable-title__center">法人名</th>
                                <td className="dataTable-body dataTable-body__w355">{this.props.pageState.JYU00013}</td>
                                <th className="dataTable-title dataTable-title__w120 dataTable-title__center">代表者名</th>
                                <td className="dataTable-body dataTable-body__w355">{this.props.pageState.JYU00014}</td>
                            </tr>
                            <tr>
                                <th className="dataTable-title dataTable-title__w120 dataTable-title__center">部署名</th>
                                <td className="dataTable-body dataTable-body__w355">{this.props.pageState.JYU00017}</td>
                                <th className="dataTable-title dataTable-title__w120 dataTable-title__center">担当者名</th>
                                <td className="dataTable-body dataTable-body__w355">{this.props.pageState.JYU00019}</td>
                            </tr>
                            <tr>
                                <th className="dataTable-title is-emphasis" colSpan="4">宅地建物取引士</th>
                            </tr>
                            <tr>
                                <th className="dataTable-title dataTable-title__w120 dataTable-title__center">登録番号</th>
                                <td className="dataTable-body dataTable-body__w355">{this.props.pageState.JYU00020}</td>
                                <th className="dataTable-title dataTable-title__w120 dataTable-title__center">氏名</th>
                                <td className="dataTable-body dataTable-body__w355">{this.props.pageState.JYU00021}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}